import React, { useState } from 'react';
import {
    EuiButton,
    EuiCallOut,
    EuiFieldPassword,
    EuiFieldText,
    EuiFlexGroup,
    EuiFlexItem,
    EuiForm,
    EuiFormFieldset,
    EuiFormRow,
    EuiPanel,
    EuiSpacer,
    EuiText,
} from '@elastic/eui';
import { observer } from 'mobx-react-lite';
import { useStore } from '../stores';
import { navigate } from 'gatsby-link';

interface Credentials {
    username: string;
    password: string;
}

interface Props {
    location: {
        state: {
            callbackUrl: string;
        };
    };
}

export default observer(function LoginPage({ location }: Props) {
    const [credentials, setCredentials] = useState<Credentials>({ username: '', password: '' });
    const { userStore } = useStore();

    const handleSubmit = () => {
        userStore.validateUser(credentials.username, credentials.password).then(() => {
            if (userStore.authenticationError === '') {
                if (location && location.state && location.state.callbackUrl && location.state.callbackUrl !== '/') {
                    navigate(location.state.callbackUrl);
                } else {
                    navigate('/home');
                }
            }
        });
    };

    return (
        <EuiFlexGroup justifyContent="spaceAround" gutterSize="none" responsive={false}>
            <EuiFlexItem grow={false} className="login-flex-item">
                <EuiSpacer />
                <EuiText size="s">
                    <h2>Welcome to the</h2>
                    <h1>Hail CX Admin App</h1>
                </EuiText>
                <EuiSpacer />
                <EuiPanel>
                    <EuiForm component="form">
                        <EuiFormFieldset legend={{ children: 'Please login.' }}>
                            <EuiSpacer size="s" />
                            <EuiFormRow label="Username" fullWidth>
                                <EuiFieldText
                                    name="username"
                                    fullWidth
                                    value={credentials.username}
                                    onChange={e =>
                                        setCredentials({ username: e.target.value, password: credentials.password })
                                    }
                                />
                            </EuiFormRow>
                            <EuiFormRow label="Password" fullWidth>
                                <EuiFieldPassword
                                    name="password"
                                    fullWidth
                                    value={credentials.password}
                                    onChange={e =>
                                        setCredentials({ username: credentials.username, password: e.target.value })
                                    }
                                />
                            </EuiFormRow>
                            <EuiFormRow fullWidth>
                                <EuiButton
                                    color={'primary'}
                                    fill
                                    fullWidth
                                    onClick={() => {
                                        handleSubmit();
                                    }}>
                                    Login
                                </EuiButton>
                            </EuiFormRow>
                        </EuiFormFieldset>
                        {userStore.authenticationError && (
                            <>
                                <EuiSpacer size="s" />
                                <EuiCallOut size="s" color="danger">
                                    {userStore.authenticationError}
                                </EuiCallOut>
                            </>
                        )}
                    </EuiForm>
                </EuiPanel>
            </EuiFlexItem>
        </EuiFlexGroup>
    );
});
